import {
  APP_BOOTSTRAP_LISTENER,
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from "@angular/core";
import {
  SelfServMetaCacheService,
  SelfServAnalyticsService,
} from "@aa/selfserv/shared";
import { AppConfigService } from "@aa/common";

import { environment } from "../../environments/environment";

export function appInitializer(appConfig: AppConfigService): () => void {
  return () => appConfig.init("selfserv", environment);
}

export function selfServMeta(
  metaCache: SelfServMetaCacheService,
): () => Promise<void> {
  return () => metaCache.init(environment.selfServDomain);
}

// null bootstrap function which is used force DI to generate singleton services
// we don't need to use the args
export function serviceBootstrap(): () => void {
  return () => null;
}

// list of services which must be instantiated after bootstrap
const STARTUP_SERVICES = [SelfServAnalyticsService];

// Core selfserv providers, formerly CoreModule.forRoot().
export function provideCore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const initializerFn = appInitializer(inject(AppConfigService));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = selfServMeta(inject(SelfServMetaCacheService));
      return initializerFn();
    }),

    {
      provide: APP_BOOTSTRAP_LISTENER,
      useFactory: serviceBootstrap,
      deps: STARTUP_SERVICES,
      multi: true,
    },
  ]);
}
